import{createPortal as r}from"react-dom";import{usePortal as o}from"../hooks/usePortal";var t=function(t){var e=t.selector,m=t.children;return r(m,o(e))};export{t as Portal};
//# sourceMappingURL=Portal.js.map